import {mainQuery} from '@github-ui/react-core/future/main-query'
import {copilotAgentsAppBuilder} from '../../config/app-builder'
import type {CopilotAgentsSpacesPayload} from '../../types/copilot-agents-spaces-payload'

export function createCopilotAgentsSpacesRoute(path: string) {
  return copilotAgentsAppBuilder.createQueryRouteConfig('copilotAgentsSpacesRoute', {
    path,
    queries: [mainQuery<CopilotAgentsSpacesPayload>()],
  })
}

export const copilotAgentsSpacesRoute = createCopilotAgentsSpacesRoute('/copilot/agents/spaces')
export const canonicalCopilotAgentsSpacesRoute = createCopilotAgentsSpacesRoute('/copilot/spaces')
